import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-onboarding-banner',
  templateUrl: './onboarding-banner.component.html',
  styleUrls: ['./onboarding-banner.component.scss']
})
export class OnboardingBannerComponent implements OnInit {

  @Input() bannerText: string = "Welcome to Joy School English!";

  constructor() { }

  ngOnInit() {
  }

}
